import { createContext } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

// @types
import { FirebaseContextType } from '../@types/authentication';
//
import { firebaseConfig } from '../config';

// ----------------------------------------------------------------------

// const ADMIN_EMAILS = ['admin@kyanhealth.com'];

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.firestore();
}

export const db = firebase.firestore();
export const storage = firebase.storage();

const AuthContext = createContext<FirebaseContextType | null>(null);

const [firebaseApp] = firebase.apps;
export const firebaseFunctions = firebaseApp.functions('europe-west3');

//@ts-ignore
export type EThreeType = window.E3kit.EThree;

export { AuthContext };
